import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  ViewChild,
  viewChild,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../../core/models/response.model'
import { MatInputModule } from '@angular/material/input'
import { MatOption } from '@angular/material/core'
import { MatSelect, MatSelectChange } from '@angular/material/select'
import { DriverTypeService } from '../../../../core/services/driver/driver-type/driver-type.service'
import { LocationService } from '../../../../core/services/location/location/location.service'
import { ServiceTypeService } from '../../../../core/services/service/service-type/service-type.service'
import { ServiceSpecificationService } from '../../../../core/services/service/service-specification/service-specification.service'
import { VehicleTypeService } from '../../../../core/services/vehicle/vehicle-type/vehicle-type.service'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from '@angular/material/datepicker'
import { convertCurrency } from '../../../../shared/utils/utils'
import moment from 'moment'
import { ModalSupplierComponent } from '../../../person/supplier/modal_supplier/modal-supplier.component'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatSlideToggle } from '@angular/material/slide-toggle'
import { CurrencyInputDirective } from '../../../../shared/directives/currencyInput'
import { provideNgxMask } from 'ngx-mask'
import { TariffTableDefaultComponent } from '../../tariff-table-default/tariff-table-default.component'
import { MatDivider } from '@angular/material/divider'
import { TariffService } from '../../../../core/services/tariff/tariff/tariff.service'
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs'

@Component({
  selector: 'tariff-client-form-edit',
  imports: [
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatOption,
    MatSelect,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    FormsModule,
    MatSlideToggle,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    CurrencyInputDirective,
    TariffTableDefaultComponent,
    MatTabsModule,
  ],
  templateUrl: './tariff-client-form-edit.component.html',
  styleUrl: './tariff-client-form-edit.component.scss',
  providers: [
    DriverTypeService,
    LocationService,
    ServiceTypeService,
    ServiceSpecificationService,
    VehicleTypeService,
    TariffService,
    provideNgxMask(),
  ],
  standalone: true,
})
export class TariffClientFormEditComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private driverTypeService: DriverTypeService,
    private locationService: LocationService,
    private serviceTypeService: ServiceTypeService,
    private serviceSpecificationService: ServiceSpecificationService,
    private vehicleTypeService: VehicleTypeService,
    private tariffService: TariffService,
    private dialogRef: MatDialogRef<TariffClientFormEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private snackbar: SnackbarCustomService,
  ) {
    this.idClient = data.idClient
    if (data && data.edit) {
      this.edit = true
      this.item = data.item
    }
  }

  datepicker = viewChild<MatDatepicker<any>>('birth')
  @Output() response = new EventEmitter()
  @ViewChild('tabGroup') tabGroup: MatTabGroup | undefined

  idClient: number = 0
  edit: boolean = false
  item: any = {}
  form: FormGroup = new FormGroup({})
  loading: boolean = false
  listLocation: any[] = []
  listTypeVehicle: any[] = []
  listTypeDriver: any[] = []
  listTypeService: any[] = []
  listServiceSpecification: any[] = []

  supplierSelected: any = {}

  ngOnInit(): void {
    this.getLocation()
    this.getTypeService()
    this.getTypeVehicle()
    this.getTypeDriver()
    this.createForm()
    if (this.edit) {
      this.fillForm(this.item)
    }
  }

  getLocation() {
    this.locationService.listLocation().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listLocation = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  getTypeService() {
    this.serviceTypeService.listServiceType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listTypeService = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  getTypeVehicle() {
    this.vehicleTypeService.listVehicleType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listTypeVehicle = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  getTypeDriver() {
    this.driverTypeService.listDriverType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listTypeDriver = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  onSelectionChangeServiceSpecification(event: MatSelectChange) {
    this.form.get('specificationService')!.setValue('')
    this.form.get('driverType')!.setValue('')
    this.form.get('vehicleType')!.setValue('')
    this.form.get('vehicleType')!.clearValidators()
    this.form.get('driverType')!.clearValidators()
    this.form.get('vehicleType')!.disable()
    this.form.get('driverType')!.disable()
    if (event.value >= 0) {
      this.getServiceSpecification(event.value)
    }
  }

  getServiceSpecification(idType: number, idService: number = -1) {
    this.listServiceSpecification = []
    this.serviceSpecificationService
      .listServiceSpecificationByType(idType)
      .subscribe({
        next: (response: ResponseRequestModel) => {
          this.listServiceSpecification = response.data ?? []
          if (idService >= 0) {
            this.checkService(
              this.listServiceSpecification.find((ele) => {
                return ele.id == idService
              }),
            )
          }
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
        },
        complete: () => {},
      })
  }

  addTariff() {
    this.loading = true
    const model = this.createModel()
    if (this.edit) {
      this.tariffService.editTariff(model).subscribe({
        next: (response: ResponseRequestModel) => {
          this.snackbar.success(response.message)
          this.response.emit(true)
          this.close()
        },
        error: (err: ErrorRequestModel) => {
          this.loading = false
          this.snackbar.errorRequest(err)
        },
        complete: () => {
          this.loading = false
          this.form.reset()
        },
      })
    } else {
      this.tariffService.createTariff(model).subscribe({
        next: (response: ResponseRequestModel) => {
          this.snackbar.success(response.message)
          this.response.emit(true)
          this.close()
        },
        error: (err: ErrorRequestModel) => {
          this.loading = false
          this.snackbar.errorRequest(err)
        },
        complete: () => {
          this.loading = false
          this.form.reset()
        },
      })
    }
  }

  checkForm() {
    if (this.form.valid) {
      return true
    } else {
      return false
    }
  }

  close() {
    this.dialogRef.close()
  }

  getDescription(id: number, list: any[]) {
    let index = list.findIndex((ele) => {
      return ele.id == id
    })
    return index > -1 ? list[index].descricao : ''
  }

  createModel() {
    if (this.edit) {
      return {
        id: this.item.id,
        tipoId: 2,
        origemId: this.form.get('origin')!.value,
        destinoId: this.form.get('destination')!.value,
        tipoServicoId: this.form.get('serviceType')!.value,
        servicoId: this.form.get('specificationService')!.value,
        tipoVeiculoId:
          this.form.get('vehicleType')!.value != ''
            ? this.form.get('vehicleType')!.value
            : 0,
        tipoMotoristaId:
          this.form.get('driverType')!.value != ''
            ? this.form.get('driverType')!.value
            : 0,
        clienteId: this.idClient,
        fornecedorId: this.supplierSelected.id ? this.supplierSelected.id : 0,
        custo: convertCurrency(this.form.get('cost')!.value),
        custoHoraExtra: convertCurrency(this.form.get('costOvertime')!.value),
        custoKmExtra: convertCurrency(this.form.get('costKmExtra')!.value),
        ativo: 'S',
        // ativo: this.form.get('active')!.value ? 'S' : 'N',
        dataValidade: moment(this.form.get('validity')!.value).format(
          'DD/MM/YYYY',
        ),
        perimetroUrbano: this.form.get('urbanPerimeter')!.value ? 'S' : 'N',
        // standard: this.form.get('standard')!.value ? 'S' : 'N',
        standard: 'N',
      }
    } else {
      return {
        tipoId: 2,
        clienteId: this.idClient,
        origemId: this.form.get('origin')!.value,
        destinoId: this.form.get('destination')!.value,
        tipoServicoId: this.form.get('serviceType')!.value,
        servicoId: this.form.get('specificationService')!.value,
        tipoVeiculoId:
          this.form.get('vehicleType')!.value != ''
            ? this.form.get('vehicleType')!.value
            : 0,
        tipoMotoristaId:
          this.form.get('driverType')!.value != ''
            ? this.form.get('driverType')!.value
            : 0,
        fornecedorId: this.supplierSelected.id ? this.supplierSelected.id : 0,
        custo: convertCurrency(this.form.get('cost')!.value),
        custoHoraExtra: convertCurrency(this.form.get('costOvertime')!.value),
        custoKmExtra: convertCurrency(this.form.get('costKmExtra')!.value),
        ativo: 'S',
        // ativo: this.form.get('active')!.value ? 'S' : 'N',
        dataValidade: moment(this.form.get('validity')!.value).format(
          'DD/MM/YYYY',
        ),
        perimetroUrbano: this.form.get('urbanPerimeter')!.value ? 'S' : 'N',
        // standard: this.form.get('standard')!.value ? 'S' : 'N',
        standard: 'N',
      }
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      serviceType: ['', [Validators.required]],
      specificationService: ['', [Validators.required]],
      vehicleType: [''],
      driverType: [''],
      origin: ['', [Validators.required]],
      destination: ['', [Validators.required]],
      cost: ['', [Validators.required]],
      costOvertime: ['', [Validators.required]],
      costKmExtra: ['', [Validators.required]],
      validity: ['', [Validators.required]],
      // active: [''],
      // supplier: [''],
      // standard: [''],
      urbanPerimeter: [''],
    })
    this.form.get('vehicleType')!.disable()
    this.form.get('driverType')!.disable()
  }

  fillForm(item: any, alterTab: boolean = false) {
    if (item) {
      console.log('item', item)
      this.getServiceSpecification(item.tipoServicoId, item.servicoId)
      this.supplierSelected = {
        id: this.item.fornecedorId,
        descricao: this.item.fornecedor ?? '',
      }
      this.form.get('serviceType')!.setValue(item.tipoServicoId)
      this.form.get('specificationService')!.setValue(item.servicoId)
      this.form.get('vehicleType')!.setValue(item.tipoVeiculoId ?? '')
      this.form.get('driverType')!.setValue(item.tipoMotoristaId ?? '')
      this.form.get('origin')!.setValue(item.origemId)
      this.form.get('destination')!.setValue(item.destinoId)
      this.form.get('cost')!.setValue(convertCurrency(item.custo))
      this.form
        .get('costOvertime')!
        .setValue(convertCurrency(item.custoHoraExtra))
      this.form.get('costKmExtra')!.setValue(convertCurrency(item.custokmExtra))
      this.form
        .get('validity')!
        .setValue(moment(item.dataValidade, 'DD/MM/YYYY').toDate())
      // this.form
      //   .get('active')!
      //   .setValue(item.ativo.toLowerCase() == 's' ? true : false)
      // this.form.get('supplier')!.setValue(item.fornecedor ?? '')
      // this.form
      //   .get('standard')!
      //   .setValue(item.standard.toLowerCase() == 's' ? true : false)
      this.form
        .get('urbanPerimeter')!
        .setValue(item.perimetroUrbano.toLowerCase() == 's' ? true : false)
      if (this.tabGroup && alterTab) {
        this.tabGroup.selectedIndex = 0
      }
    }
  }

  onSelectionChangeService(event: MatSelectChange) {
    this.form.get('driverType')!.setValue('')
    this.form.get('vehicleType')!.setValue('')
    let specificationService = this.listServiceSpecification.find((ele) => {
      return ele.id == event.value
    })
    this.checkService(specificationService)
  }

  checkService(specificationService: any) {
    if (specificationService) {
      if (
        specificationService.exigeVeiculo &&
        specificationService.exigeVeiculo.toLowerCase() == 's'
      ) {
        this.form.get('vehicleType')!.setValidators(Validators.required)
        this.form.get('driverType')!.setValidators(Validators.required)
        this.form.get('vehicleType')!.enable()
        this.form.get('driverType')!.enable()
      } else {
        this.form.get('vehicleType')!.clearValidators()
        this.form.get('driverType')!.clearValidators()
        this.form.get('vehicleType')!.disable()
        this.form.get('driverType')!.disable()
      }
    }
  }

  addSupplier() {
    const dialogRef = this.dialog.open(ModalSupplierComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1200px',
      minWidth: '1200px',
      maxHeight: '650px',
      data: {
        item: this.supplierSelected,
        multiSelect: false,
      },
    })
    dialogRef.componentInstance.responseSingle.subscribe((response) => {
      if (response) {
        if (response.remove == false) {
          this.supplierSelected = response.selection
          this.form
            .get('supplier')!
            .setValue(this.supplierSelected.nomeFantasia)
        } else {
          this.supplierSelected = {}
          this.form.get('supplier')!.setValue('')
        }
      }
    })
  }

  openDatepicker() {
    this.datepicker()?.open()
  }

  selectItem(item: any) {
    this.fillForm(item, true)
  }
}
